<!-- 任务点排名 -->
<template>
  <div ref="wholePage">
    <a-card title="工单创建时间散点图" size="small">
      <div id="ticket-create-time" :style="{ height: height, width: width }" />
    </a-card>
  </div>
</template>
<script>
import { ticketCreateTime } from '@/api/data/ticket';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '360px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      markLineOpt: {
        label: {
          formatter: '工作日',
          align: 'right'
        },

        tooltip: {
          formatter: '工作时间',
          show: true,
          trigger: 'axis'
        },
        data: [
          [
            {
              coord: [0, 6],
              symbol: 'none'
            },
            {
              coord: [24, 6],
              symbol: 'none'
            }
          ],
          [
            {
              coord: [10, 0],
              symbol: 'none'
            },
            {
              coord: [10, 7],
              symbol: 'none'
            }
          ],
          [
            {
              coord: [21, 0],
              symbol: 'none'
            },
            {
              coord: [21, 7],
              symbol: 'none'
            }
          ]
        ]
      },
      option: {
        grid: [{ left: '1%', top: '7%', width: '100%', height: '80%' }],
        tooltip: {
          showDelay: 0,
          // show: true,
          trigger: 'axis'
        },
        // xAxis: {
        //   // scale: true
        //   boundaryGap: false,
        //   type: 'category',
        //   data: ['1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00',
        //     '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00', '24:00', '']
        // },
        // yAxis: {
        //   // scale: true
        //   boundaryGap: false,
        //   type: 'category',
        //   data: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日', '']
        // },
        xAxis: [{ gridIndex: 0, min: 0, max: 24 }],
        yAxis: [{ gridIndex: 0, min: 1, max: 8 }],
        series: [
          {
            name: 'I',
            type: 'scatter',
            data: null,
            markLine: null
          }
        ]
      }
    };
  },
  watch: {
    filterForm() {
      this.getData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/component/title');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/legend');
    require('echarts/lib/chart/scatter');
    require('echarts/lib/component/markLine');
    this.myChart = echarts.init(document.getElementById('ticket-create-time'));
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    calculateColor(value) {
      let color = '';

      if (value > 24) {
        color = '#2F4F4F';
      } else if (value > 12 && value <= 24) {
        color = '#698B69';
      } else if (value > 6 && value <= 12) {
        color = '#B4EEB4';
      } else {
        color = '#C1FFC1';
      }

      return color;
    },
    getData() {
      this.loading = true;
      ticketCreateTime(this.filterForm)
        .then(res => {
          // 假设返回的数据格式为所需格式
          this.option.series[0].markLine = this.markLineOpt;
          Object.keys(res.data.xSerious).forEach(key => {
            const data = {
              name: res.data.xSerious[key].name,
              type: 'scatter',
              data: [[res.data.xSerious[key].ySerious, res.data.xSerious[key].xSerious]],
              color: this.calculateColor(res.data.xSerious[key].isOverTime)
            };
            this.option.series.push(data);
          });
          this.drawChart();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    close() {
      this.detailVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
